<template>
  <div class="indexbox">
    <!-- <div class="intro">
      <p><span class="title">π-BatKB:</span> The bat proteomic knowledge base under the support of π-HuB Project</p>
      <ul>
        <li>Covers twenty-three bat tissues, nine biological systems, and seven functional groups, providing a view of bat proteomics.  </li>
        <li>Enables focused exploration of protein expression patterns across three species: bats, humans, and mice, supporting cross-species comparative analysis of protein expression profiles. </li>
      </ul>
    </div> -->
    <div class="bannerblue">
      <div class="bannerwhite">
        <div class="titlebg mt20">
          <span class="fontwhite textCenter"><span class="fontgreen">π-XenoSTAR:</span> Xenopus Spatiotemporal Atlas of Transcriptomics & Proteomics at Subcellular Resolution</span>
        </div>
        <div class="textCenter mt20">
          <img src="@/assets/home/banner2.png" alt="" style="width: 75%;">
          <!-- <img
            src="@/assets/home/banner.png"
            srcset="banner-small.jpg 800w, banner-medium.jpg 1200w, @/assets/home/banner.png 1920w"
            sizes="100vw"
            alt="Banner"
            class="banner-img"
            style="width: 100%;"> -->
        </div>
      </div>
    </div>
    <div class="bannerfooter"></div>
    <div class="contents mt30">
      <div class="introDiv">
        π-XenoSTAR database is a high-resolution, spatiotemporal multi-omics atlas of early Xenopus embryogenesis, integrating transcriptomic and proteomic landscapes across six key developmental stages. By systematically cryo-sectioning embryos along the animal–vegetal (AN–VG) axis, the database comprises 707 spatial transcriptome sections and 692 proteome sections, capturing over 31,000 genes and 8,642 proteins, respectively. With broad organelle coverage and subcellular resolution, the data reveal fine-grained spatial polarity and developmental progression.
      </div>
      <el-row :gutter="30" class="menuDiv mt30">
        <el-col :span="12">
          <div class="flex">
            <div>
              <img src="@/assets/home/1.png" alt="" class="introimg">
            </div>
            <div class="ml20">
              <h3>Experimental techniques</h3>
              <div class="mt10">
                Experimental procedures used to generate the high-resolution spatial transcriptomic and proteomic data.
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex">
            <div>
              <img src="@/assets/home/2.png" alt="" class="introimg">
            </div>
            <div class="ml20">
              <h3>Data statistics</h3>
              <div class="mt10">
                Overview of the core data statistics of all spatial sections across six stages and two omics.
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" class="menuDiv mt20">
        <el-col :span="12">
          <div class="flex">
            <div>
              <img src="@/assets/home/3.png" alt="" class="introimg">
            </div>
            <div class="ml20">
              <h3>Data explorer</h3>
              <div class="mt10">
                Interactive visualization tool to explore gene and protein expression patterns.
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex">
            <div>
              <img src="@/assets/home/4.png" alt="" class="introimg">
            </div>
            <div class="ml20">
              <h3>Download</h3>
              <div class="mt10">
                Processed data and metadata is available for the research community.
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="referContent mt30">
        <h3>How to cite</h3>
        <div class="referinfo mt10">
          Mapping Subcellular Molecular Localization and Organization using Optimal Transport
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {  } from '@/api'
  export default {
    name: 'home',
    data() {
      return {
        bgStyle: {
          
        },
      };
    },
    computed: {},
    mounted() {
    },
    created() {
      
    },
    watch: {

    },
    methods: {
    },
  };
</script>
<style lang="scss" scoped>
$bg_color: #ffffff;
$min_color: #1b82d1;
$font_color: #333333;
$hover_color: #409eff;
$h3_color: #00557A;
$boder-color: #C6DBE3;
$divbg-color: #E3F1F7;
$overviewbg-color: #F1F7FA;
$hover_color: #0379b0;
$diseasebg_color: #73CBF0;
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .outerdiv {
    height: 100px;
    background: $overviewbg-color;
    border-radius: 10px;
    border:1px solid $boder-color;
    display: flex;
    justify-content: center;
    align-items: center;
    .kindouter {
      // width: 216px;
      height: 54px;
      line-height: 54px;
      background: #73cbf0;
      border-radius: 6px 6px 6px 6px;
      position: relative;
      cursor: pointer;
      text-align: center;
      &:hover {
        background: $hover_color;
        color: #fff;
      }
    }
    .isactive {
      background: $hover_color;
      color: #fff;
    }
    // .kindtext {
    //   position: absolute;
    //   margin: auto;
    //   top: 35%;
    //   left: 80px;
    //   bottom: 0;
    // }
  }
  .intro {
    text-align: justify;
    color: #434343;
    padding: 15px;
    border-radius: 10px;
    font-size: 20px;
    background: #f2fbff;
    border: 1px solid #c6dbe3;
    .title {
      font-weight: 700;
      font-size: 20px;
    }
    ul {
      padding-left: 50px;
      li {
        list-style: none;
      }
    }
  }
  .statouter {
    .homeHuman {
      .humancss {
        display: block;
        width: 100%;
        margin-top: 30px;
        margin-left: -3%;
      }
    }
  }
  .contactouter {
    .contents {
      padding-left: 15px;
      padding-right: 15px;
      .title {
        font-weight: 700;
      }
    }
  }
  .linkouter {
    a {
      color: $min_color;
    }
  }
  .indexbox {
    .bannerblue {
      background: #C3E1EF;
      display: flex;
      justify-content: center;
      align-items: center;
      .bannerwhite {
        width: 80%;
        background:#ffffff;
        display: grid;
        place-items: center;
        .titlebg {
          background-image: url('../assets/home/title.png');
          background-size: cover; /* 或 cover */
          background-repeat: no-repeat;
          background-position: center;
          width: 90%;
          text-align: center;
          height: 70%;
          /* vertical-align: middle; */
          display: flex;
          align-items: center;
          justify-content: center;
          .fontwhite {
            color: #ffffff;
            font-size: 16px;
          }
          .fontgreen {
            color: #02FF8C;
            font-size: 16px;
          }
        }
      }
    }
    .bannerfooter {
      // background-image: url('../assets/home/bannerfooter.png');
      background: #D2D3D4;
      height: 10px;
      // background-size: cover; /* 或 cover */
      // background-repeat: no-repeat;
      // background-position: center;
      width: 80%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .bannerimg {
      width: 100%;
      height: 400px;
      background-image: url("../assets/home/banner.png");
      background-size: cover; /* 关键属性：覆盖容器 */
      background-position: center; /* 聚焦中心区域 */
      background-repeat: no-repeat;
    }
    .contents {
      width: 80%;
      font-size: 18px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      .referContent {
        .referinfo {
          background: #F0F4F6;
          // border-radius: 15px;
          padding: 15px;
        }
      }
      .introDiv {
        background: #F0F4F6;
        padding: 20px;
      }
      .menuDiv {
        h3 {
          color: #17754A;
        }
        .introimg {
          height: 65px;
          margin-top: 10px;
        }
      }
    }
  }
</style>
